/* istanbul ignore file */
import { useMemo } from 'react'
import { match, P } from 'ts-pattern'
import useWindowDimensions from '../useWindowDimensions'
import useIsMounted from '../useIsMounted'
export type Breakpoint =
  | 'mobile'
  | 'tablet'
  | 'laptop'
  | 'desktop'
  | 'large-desktop'

const breakpoints = {
  mobile: 300,
  tablet: 760,
  laptop: 992,
  desktop: 1200,
  'large-desktop': 1500,
}

const useBreakpoints = (
  serverSideDefault: Breakpoint = 'mobile'
): Breakpoint => {
  const { width } = useWindowDimensions()
  const isMounted = useIsMounted()

  const breakpoint = useMemo<Breakpoint>(() => {
    if (!isMounted) return serverSideDefault
    return match<number, Breakpoint>(width)
      .with(
        P.when((w: number) => w < breakpoints.tablet),
        () => 'mobile'
      )
      .with(
        P.when((w: number) => w < breakpoints.laptop),
        () => 'tablet'
      )
      .with(
        P.when((w: number) => w < breakpoints.desktop),
        () => 'laptop'
      )
      .with(
        P.when((w: number) => w < breakpoints['large-desktop']),
        () => 'desktop'
      )
      .otherwise(() => 'large-desktop')
  }, [isMounted, serverSideDefault, width])

  return breakpoint
}

export default useBreakpoints
